import store from '@/states/index.js'

import Decisions from '../DecisionComponent.vue'

export default [
    {
        path: '/decision',
        component: Decisions,
        name: 'decision',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 3){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]